import slice from './slice.product';
import * as productTypes from './types.product';

export const { reducer: productState, actions: productActions } = slice;
export { productTypes };
export { default as productSaga } from './saga.product';
export { default as productSelector } from './selector.product';
export default slice;
